document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('ProductGridContainer');
  var root = document.querySelector('.pill-filters');
  var groups = document.querySelectorAll('.pill-filters__options');
  if (!root || !groups.length || !container) return;

  var status = document.getElementById('PillFiltersStatus');
  var countEl = document.getElementById('PillFiltersCount');
  var chipsEl = document.getElementById('PillFiltersChips');
  var emptyEl = document.getElementById('PillFiltersEmpty');
  var sortInputs = slice(document.querySelectorAll('.pill-filters__pill--sort input'));
  var allLoaded = false;
  var loadPromise = null;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  function grid() {
    return document.getElementById('product-grid');
  }

  function gridItems() {
    var g = grid();
    return g ? slice(g.querySelectorAll('.grid__item:not(.pill-filters__skeleton)')) : [];
  }

  function totalPages() {
    var g = grid();
    return g ? parseInt(g.getAttribute('data-total-pages') || '1', 10) : 1;
  }

  function isComplete() {
    return allLoaded || totalPages() <= 1;
  }

  function filterPills(group) {
    return slice(group.querySelectorAll('.pill-filters__pill:not(.pill-filters__pill--sort)'));
  }

  function stampOrder() {
    gridItems().forEach(function (li, i) {
      li.setAttribute('data-pill-order', i);
    });
  }

  function refreshAvailability() {
    var items = gridItems();
    var complete = isComplete();
    groups.forEach(function (group) {
      var groupName = group.getAttribute('data-pill-group');
      var counts = {};
      if (complete) {
        items.forEach(function (item) {
          var seen = {};
          (item.getAttribute('data-pill-' + groupName) || '').split(' ').forEach(function (v) {
            if (!v || seen[v]) return;
            seen[v] = true;
            counts[v] = (counts[v] || 0) + 1;
          });
        });
      }

      var anyAvailable = false;
      filterPills(group).forEach(function (pill) {
        var input = pill.querySelector('input');
        var num = pill.querySelector('.pill-filters__num');
        var available = complete ? !!counts[input.value] : true;
        pill.classList.toggle('is-available', available);
        if (!available) input.checked = false;
        if (available) anyAvailable = true;
        if (num) num.textContent = complete && counts[input.value] ? '(' + counts[input.value] + ')' : '';
      });

      var details = group.closest('.pill-filters__group');
      if (details) details.classList.toggle('is-available', anyAvailable);
    });
  }

  function getSelected() {
    var selected = {};
    groups.forEach(function (group) {
      var groupName = group.getAttribute('data-pill-group');
      var values = [];
      filterPills(group).forEach(function (pill) {
        var input = pill.querySelector('input');
        if (input.checked) values.push(input.value);
      });
      if (values.length) selected[groupName] = values;
    });
    return selected;
  }

  function activeSort() {
    var sort = null;
    sortInputs.forEach(function (input) {
      if (input.checked) sort = input.value;
    });
    return sort;
  }

  function applySort() {
    var g = grid();
    if (!g) return;
    var sort = activeSort();
    var items = gridItems();
    var sorted = items.slice().sort(function (a, b) {
      if (sort) {
        var pa = parseFloat(a.getAttribute('data-pill-price-value') || '0');
        var pb = parseFloat(b.getAttribute('data-pill-price-value') || '0');
        if (pa !== pb) return sort === 'asc' ? pa - pb : pb - pa;
      }
      return parseInt(a.getAttribute('data-pill-order') || '0', 10) - parseInt(b.getAttribute('data-pill-order') || '0', 10);
    });
    // Skip touching the DOM when the order is already right (re-inserting every card is expensive)
    var changed = sorted.some(function (li, i) { return li !== items[i]; });
    if (!changed) return;
    var frag = document.createDocumentFragment();
    sorted.forEach(function (li) {
      frag.appendChild(li);
    });
    g.appendChild(frag);
  }

  function makeChip(text, onRemove) {
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'pill-filters__chip';
    chip.setAttribute('aria-label', 'הסר ' + text);
    chip.innerHTML = '<span>' + text + '</span><span aria-hidden="true">✕</span>';
    chip.addEventListener('click', onRemove);
    return chip;
  }

  function renderChips() {
    if (!chipsEl) return;
    chipsEl.innerHTML = '';
    var any = false;

    groups.forEach(function (group) {
      var groupName = group.getAttribute('data-pill-group');
      var label = group.getAttribute('data-pill-label') || '';
      filterPills(group).forEach(function (pill) {
        var input = pill.querySelector('input');
        if (!input.checked) return;
        any = true;
        var text = pill.querySelector('.pill-filters__text').textContent.trim();
        var full = groupName === 'brand' || groupName === 'category' ? text : label + ': ' + text;
        chipsEl.appendChild(makeChip(full, function () {
          input.checked = false;
          onChange();
        }));
      });
    });

    var sort = activeSort();
    if (sort) {
      any = true;
      var sortInput = sortInputs.filter(function (i) { return i.value === sort; })[0];
      var sortText = sortInput.closest('.pill-filters__pill').querySelector('.pill-filters__text').textContent.trim();
      chipsEl.appendChild(makeChip('מיון: ' + sortText, function () {
        sortInput.checked = false;
        onChange();
      }));
    }

    if (any) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'pill-filters__clear';
      clear.textContent = 'נקה הכל';
      clear.addEventListener('click', clearAll);
      chipsEl.appendChild(clear);
    }
  }

  function updateBadges(selected) {
    groups.forEach(function (group) {
      var groupName = group.getAttribute('data-pill-group');
      var details = group.closest('.pill-filters__group');
      var badge = details ? details.querySelector('.pill-filters__badge') : null;
      if (!badge) return;
      var n = (selected[groupName] || []).length;
      if (groupName === 'price' && activeSort()) n += 1;
      badge.textContent = n;
      badge.hidden = n === 0;
    });
  }

  function applyFilters(animate) {
    var selected = getSelected();
    var groupNames = Object.keys(selected);
    var visibleCount = 0;
    var entering = [];

    gridItems().forEach(function (item) {
      var visible = true;
      groupNames.forEach(function (groupName) {
        var itemValues = (item.getAttribute('data-pill-' + groupName) || '').split(' ');
        var matches = selected[groupName].some(function (v) {
          return itemValues.indexOf(v) !== -1;
        });
        if (!matches) visible = false;
      });
      var wasVisible = item.style.display !== 'none';
      item.style.display = visible ? '' : 'none';
      if (visible) {
        visibleCount++;
        if (animate && !wasVisible) entering.push(item);
      }
    });

    // Fade in only the first cards that reappear. No forced layout per card: going from
    // display:none to visible already (re)starts the CSS animation. (Forcing a layout per card
    // froze the page for ~2s when "נקה הכל" brought back ~230 cards.)
    entering.forEach(function (item, i) {
      item.classList.toggle('is-entering', i < 24);
    });

    var active = groupNames.length > 0 || !!activeSort();
    if (countEl) countEl.textContent = isComplete() ? visibleCount + ' מוצרים' : '';
    renderChips();
    updateBadges(selected);
    if (emptyEl) emptyEl.hidden = !(active && visibleCount === 0 && isComplete());
  }

  function showSkeleton(n) {
    var g = grid();
    if (!g) return;
    for (var i = 0; i < n; i++) {
      var li = document.createElement('li');
      li.className = 'grid__item pill-filters__skeleton';
      li.setAttribute('aria-hidden', 'true');
      li.innerHTML =
        '<div class="pill-filters__skel" style="height:180px"></div>' +
        '<div class="pill-filters__skel" style="height:12px;margin-top:10px;width:80%"></div>' +
        '<div class="pill-filters__skel" style="height:12px;margin-top:6px;width:40%"></div>';
      g.appendChild(li);
    }
  }

  function hideSkeleton() {
    slice(document.querySelectorAll('.pill-filters__skeleton')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  // Loads every page of the collection (only after the first filter/sort click) so results cover all products.
  function loadAllPages() {
    var g = grid();
    if (!g) return Promise.resolve();
    var total = totalPages();
    var current = parseInt(g.getAttribute('data-current-page') || '1', 10);
    var sectionId = g.getAttribute('data-id');
    var baseUrl = g.getAttribute('data-collection-url') || window.location.pathname;
    if (total <= 1 || !sectionId) {
      allLoaded = true;
      return Promise.resolve();
    }

    if (status) status.hidden = false;
    showSkeleton(8);

    var pages = [];
    for (var p = 1; p <= total; p++) {
      if (p !== current) pages.push(p);
    }

    return Promise.all(
      pages.map(function (p) {
        var url = baseUrl + '?page=' + p + '&section_id=' + encodeURIComponent(sectionId);
        return fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return { page: p, items: slice(doc.querySelectorAll('#product-grid .grid__item')) };
          })
          .catch(function () { return { page: p, items: [] }; });
      })
    ).then(function (results) {
      hideSkeleton();
      var g2 = grid();
      if (!g2) return;
      var byPage = {};
      results.forEach(function (r) { byPage[r.page] = r.items; });
      byPage[current] = gridItems();

      var frag = document.createDocumentFragment();
      for (var p = 1; p <= total; p++) {
        (byPage[p] || []).forEach(function (li) { frag.appendChild(li); });
      }
      g2.innerHTML = '';
      g2.appendChild(frag);

      gridItems().forEach(function (li, i) {
        li.classList.remove('animate-item', 'animate-item--child');
        li.style.setProperty('--index', i);
      });
      stampOrder();

      container.querySelectorAll('.pagination-wrapper, .pagination').forEach(function (el) { el.hidden = true; });

      if (current > 1 && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', baseUrl + window.location.hash);
      }
      allLoaded = true;
      if (status) status.hidden = true;
    });
  }

  function ensureLoaded() {
    if (isComplete()) {
      allLoaded = true;
      return Promise.resolve();
    }
    if (!loadPromise) loadPromise = loadAllPages();
    return loadPromise;
  }

  function onChange() {
    applyFilters(true);
    ensureLoaded().then(function () {
      refreshAvailability();
      applySort();
      applyFilters(true);
    });
  }

  function clearAll() {
    groups.forEach(function (group) {
      group.querySelectorAll('input:checked').forEach(function (input) { input.checked = false; });
    });
    applySort();
    applyFilters(true);
  }

  groups.forEach(function (group) {
    group.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.hasAttribute('data-sort') && target.checked) {
        sortInputs.forEach(function (input) {
          if (input !== target) input.checked = false;
        });
      }
      onChange();
    });
  });

  slice(document.querySelectorAll('[data-pill-clear]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.pill-filters__panel');
      var group = panel ? panel.querySelector('.pill-filters__options') : null;
      if (!group) return;
      group.querySelectorAll('input:checked').forEach(function (input) { input.checked = false; });
      onChange();
    });
  });

  slice(document.querySelectorAll('[data-pill-clear-all]')).forEach(function (btn) {
    btn.addEventListener('click', clearAll);
  });

  // Only one panel open at a time
  var allGroups = slice(root.querySelectorAll('.pill-filters__group'));
  allGroups.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      allGroups.forEach(function (other) {
        if (other !== details && other.open) other.open = false;
      });
    });
  });

  // Close any open panel when clicking outside the bar
  document.addEventListener('click', function (event) {
    if (root.contains(event.target)) return;
    allGroups.forEach(function (d) { d.open = false; });
  });

  // Drop the fade class once it has played, so later re-sorts don't replay it on every card
  container.addEventListener('animationend', function (event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains('is-entering')) t.classList.remove('is-entering');
  });

  stampOrder();
  refreshAvailability();
  applyFilters(false);

  new MutationObserver(function () {
    refreshAvailability();
    applyFilters(false);
  }).observe(container, { childList: true });
});